:host {
  display: contents;
}

td {
  background-color: inherit;
  max-width: inherit;
  min-width: inherit;
  padding-block: var(--ld-table-cell-padding-y);
  padding-inline: var(--ld-table-cell-padding-x);
}
